import { AuthInstance } from "../../utils/axiosConfig";
import { setErrors } from "../Error/actions";
import { resetErrors } from "../Error/epics";
import { setLoading } from "../Common/actions";
import * as epics from "./epics";

export const fetchJobs = (companyId) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      dispatch(resetErrors());
      let response = await AuthInstance.get(`jobs/?company_id=${companyId}`);
      let data = await response.data;
      dispatch(epics.setJobs(data.payload.data));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setErrors(error));
      dispatch(setLoading(false));
    }
  };
};

export const createJobs = (navigate, job, companyId) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      dispatch(resetErrors());

      let response = await AuthInstance.post(`jobs/`, {
        ...job,
        company_id: companyId,
      });
      let data = await response.data;
      if (data.payload.data.otp_session_id) {
        dispatch(epics.setOtpInfo(data.payload.data));
        navigate(
          `/${companyId}/jobs/verify-email/${data.payload.data.job_post}`
        );
      } else {
        navigate(`/${companyId}/jobs/view/${data.payload.data.job_post}`);
      }
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setErrors(error));
      dispatch(setLoading(false));
    }
  };
};
export const updateJob = (navigate, job, jobId, companyId) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      dispatch(resetErrors());
      await AuthInstance.put(`jobs/${jobId}/`, job);
      navigate(`/${companyId}/jobs/view/${jobId}`);
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setErrors(error));
      dispatch(setLoading(false));
    }
  };
};
export const callVerifyOtp = (navigate, payload, jobId, companyId) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      dispatch(resetErrors());
      await AuthInstance.post(`jobs/verify-email/`, payload);
      navigate(`/${companyId}/jobs/view/${jobId}`);
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setErrors(error));
      dispatch(setLoading(false));
    }
  };
};
export const callSendOtp = (navigate, jobId, companyId, navigteRequire) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      dispatch(resetErrors());
      let response = await AuthInstance.post(`jobs/resend-otp/`, {
        job_post: jobId,
      });
      let data = await response.data;
      dispatch(epics.setOtpInfo(data.payload.data));
      if (navigteRequire)
        navigate(
          `/${companyId}/jobs/verify-email/${data.payload.data.job_post}`
        );
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setErrors(error));
      dispatch(setLoading(false));
    }
  };
};

export const fetchChoices = () => {
  return async (dispatch) => {
    try {
      let response = await AuthInstance.get(`jobs/choices/`);
      let data = await response.data;
      dispatch(epics.setChoices(data?.payload?.data));
    } catch (error) {
      dispatch(setErrors(error));
      dispatch(setLoading(false));
    }
  };
};
export const fetchJob = (jobId) => {
  return async (dispatch) => {
    try {
      let response = await AuthInstance.get(`jobs/${jobId}/`);
      let data = await response.data;
      dispatch(epics.setJobInfo(data?.payload?.data));
    } catch (error) {
      dispatch(setErrors(error));
      dispatch(setLoading(false));
    }
  };
};
